// SaveResponsable.tsx
import { Responsable, ResponsableForm } from "../../types";
import { useForm } from "react-hook-form";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { useEffect, useState } from "react";
import {
  useFetchPostResponsable,
  useFetchPutResponsable,
} from "@/shared/actions";
//nuevo
import { CustomAutocompleteDynamicSearch } from "@/shared/components/ui";
//
import { responsableSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";
import {  CustomAutocomplete } from "@/shared/components/ui";
// import { useFetchUsuariosSistema } from "@/shared/actions/erp/administration/usuarios";
// import { TextField, InputAdornment, CircularProgress } from "@mui/material";
import {  useFetchUsuariosSistemaSinModulos, useFetchUsuariosSistemaPorArreglo } from "@/shared/actions/erp/administration/usuarios";

type SaveResponsableProps = {
  titulo: string;
  data?: Responsable | null;
};

export default function SaveResponsable({ titulo, data }: SaveResponsableProps) {
  const returnUrl = ROUTER_PATHS.control_cambios.responsableNav;
  const cargoOptions = [
    { value: "Coordinador", label: "Coordinador" },
    { value: "Ejecutivo", label: "Ejecutivo" },
    { value: "Tecnico", label: "Tecnico" },
    { value: "Auxiliar", label: "Auxiliar" },
    { value: "Jefe de departamento", label: "Jefe de departamento" },
  ];
  
  
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const createResponsable = useFetchPostResponsable({
    navigate,
    returnUrl,
  });
  const updateResponsable = useFetchPutResponsable(navigate, returnUrl);

  const form = useForm<ResponsableForm>({
    resolver: yupResolver(responsableSchema) as any,
    mode: "onChange",
    defaultValues: {
      cargo: "",
      correo: "",
      telefono: "",
      usuarioId: undefined as unknown as number,
      estado: true,
    },
  });
  
  //usuarios
    const [writtenText, setWrittenText] = useState("");
     const { data: usuariosRes, isLoading: loadingUsuarios } = useFetchUsuariosSistemaSinModulos({
    enabled: true,                                   // trae la 1ª página al abrir
    // params: { page: 1, page_size: 20, search: writtenText },
    params: { page: 1, page_size: 20, razon_social: writtenText },
  });
  // const usuarios = usuariosRes?.data?.data ?? [];
  const usuarios = (usuariosRes?.data?.data ?? []).map((u) => ({
    id: u.id as number,
    razon_social: u.profile?.razon_social ?? u.username,
    email: u.email,
    telefono: u.empleado?.telefono_1
  }));

  const { data: usuarioEditRes } = useFetchUsuariosSistemaPorArreglo({
    enabled: !!data?.usuarioId,
    params: { usuarios: [Number(data?.usuarioId)] },
  });

   const razonSocialEdit =
    usuarioEditRes?.data?.data?.[0]?.profile?.razon_social ??
    usuarioEditRes?.data?.data?.[0]?.username ??
    "";

  const [usuarioElegido, setUsuarioElegido] = useState(false);


  
  ///
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;
    const values = {
      ...form.getValues(),
      usuarioId: Number(form.getValues().usuarioId),
    };
    if (data?.responsableId) {
      return updateResponsable.mutate({
        id: data.responsableId,
        data: values as any,
      });
    }
    return createResponsable.mutate(values);
  };

  useEffect(() => {
    if (data) {
      setShrink(true);
      // reset({ ...data });
      reset({
        cargo: data.cargo ?? "",
        correo: data.correo ?? "",
        telefono: data.telefono ?? "",
        usuarioId: data.usuarioId ?? 0,
        estado: data.estado ?? true,
      });
    }
  }, [data, reset]);
  // }, [data]);


  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      {/* <CustomTextField
        label="Cargo"
        name="cargo"
        control={form.control}
        defaultValue={form.getValues().cargo || ""}
        error={errors.cargo}
        helperText={errors.cargo?.message ?? ""}
        shrink={shrink}
      /> */}
      <CustomAutocomplete<{ value: string; label: string }>
        label="Cargo" 
        name="cargo" 
        control={form.control}
        options={cargoOptions} 
        valueKey="label" 
        actualValueKey="value"
        isLoadingData={false}
        defaultValue={form.getValues().cargo ?? ""}
        error={errors.cargo} helperText={errors.cargo?.message ?? ""}
      />
      {/* <CustomTextField
        label="ID de usuario"
        name="usuarioId"
        control={form.control}
        defaultValue={form.getValues().usuarioId ?? ""}
        error={errors.usuarioId}
        helperText={errors.usuarioId?.message ?? ""}
        shrink={shrink}
      /> */}
      {/* /** ANTES*/ }
      {/* <CustomAutocomplete<UsuariosSistemaGET>
        label="Usuario"
        name="usuarioId"
        control={form.control}
        options={usuarios}
        valueKey="username"        // lo que se MUESTRA en la lista
        actualValueKey="id"        // lo que se GUARDA en el form (el id)
        isLoadingData={loadingUsuarios}
        defaultValue={form.getValues().usuarioId ?? ""}
        error={errors.usuarioId}
        helperText={errors.usuarioId?.message ?? ""}
      /> */}
      
        <CustomAutocompleteDynamicSearch<{ id: number; razon_social: string; email: string; telefono: string | undefined }>
                label="Usuario"
                name="usuarioId"
                control={form.control}
                optionsFetched={usuarios}
                valueKey="razon_social"
                actualValueKey="id"
                isLoadingData={loadingUsuarios}
                defaultValue={form.getValues().usuarioId ?? ""}
                setWrittenText={setWrittenText} 
                optionLabelForEdit={razonSocialEdit}          // 👈 lo nuevo: alimenta la búsqueda
                onChangeRawValue={(u) => {
                  if (u) {
                    form.setValue("correo", u.email ?? "", { shouldValidate: true });
                    form.setValue("telefono", u.telefono ?? "", { shouldValidate: true });
                    setUsuarioElegido(true);
                  }
                }}
                error={errors.usuarioId}
                helperText={errors.usuarioId?.message ?? ""}
              />


      {/* <CustomAutocomplete<{ id: number; razon_social: string; email: string; telefono: string | undefined }>
          label="Usuario"
          name="usuarioId"
          control={form.control}
          options={usuarios}
          valueKey="razon_social"     // muestra la razón social
          actualValueKey="id"         // guarda el id
          isLoadingData={loadingUsuarios}
          defaultValue={form.getValues().usuarioId ?? ""}
          onChangeRawValue={(u) => {
            if (u) {
              form.setValue("correo", u.email ?? "", { shouldValidate: true });
              form.setValue("telefono", u.telefono ?? "", { shouldValidate: true })
              setUsuarioElegido(true);
            }
          }}
          error={errors.usuarioId}
          helperText={errors.usuarioId?.message ?? ""}
        /> */}
      <CustomTextField
        label="Correo"
        name="correo"
        control={form.control}
        
        disabled={!usuarioElegido}

        defaultValue={form.getValues().correo || ""}
        error={errors.correo}
        helperText={errors.correo?.message ?? ""}
        shrink={shrink}
      />
      <CustomTextField
        label="Teléfono"
        name="telefono"

        disabled={!usuarioElegido}
        control={form.control}
        defaultValue={form.getValues().telefono || ""}
        error={errors.telefono}
        helperText={errors.telefono?.message ?? ""}
        shrink={shrink}
        onChangeValue={(v) => {
          // Solo dígitos y máximo 10 (no deja escribir más)
          const limpio = String(v ?? "").replace(/\D/g, "").slice(0, 10);
          if (limpio !== v) {
            form.setValue("telefono", limpio, { shouldValidate: true });
          }
        }}
      />
    </SingleFormBoxScene>
  );
}
